"use client";
import Image from "next/image";

export function StripeCard({
  card,
}: {
  card: {
    brand: string;
    last4: string;
    exp_month: number;
    exp_year: number;
  };
}) {
  const { brand, last4, exp_month, exp_year } = card;
  const brandImagePath = cardBrandFilePaths[brand];
  const formattedMonth = String(exp_month).padStart(2, "0");
  const formattedYear = String(exp_year).slice(-2);

  return (
    <div className="flex flex-col gap-[8px] sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-[10px] sm:gap-y-[5px]">
      <div className="flex items-center gap-[8px]">
        {brandImagePath && (
          <Image
            src={brandImagePath}
            alt={brand}
            width={32}
            height={20}
            className="shrink-0"
          />
        )}
        <span className="font-mono text-sm whitespace-nowrap">
          XXXX-XXXX-XXXX-{last4}
        </span>
      </div>
      <span className="font-mono text-sm whitespace-nowrap">
        {formattedMonth}/{formattedYear}
      </span>
    </div>
  );
}
const cardBrandFilePaths: { [key: string]: string } = {
  amex: "/i/card_brand_amex.svg",
  diners: "/i/card_brand_diners.svg",
  discover: "/i/card_brand_discover.svg",
  jcb: "/i/card_brand_jcb.svg",
  mastercard: "/i/card_brand_mastercard.svg",
  visa: "/i/card_brand_visa.svg",
};
